import { render, staticRenderFns } from "./ProjectDetailsOverlay.vue?vue&type=template&id=e66acff8&scoped=true&"
import script from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailsOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailsOverlay.vue?vue&type=style&index=0&id=e66acff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66acff8",
  null
  
)

export default component.exports